/**
 * External Dependencies
 */

import './scrollreveal';
import { Fancybox } from "@fancyapps/ui";

// import './swupanimations';
import './menu';
import './swiper';
import './contentrows';
import './contentrijen';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

$(() => {
    // Verwijder lege paragrafen die enkel uit non-breaking spaces bestaan.
    document.querySelectorAll('.contentrow__paragraph p').forEach((paragraph) => {
        const textWithoutNbsp = paragraph.textContent.replace(/\u00a0/g, '').trim();

        if (!textWithoutNbsp) {
            paragraph.remove();
        }
    });

    Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });
    // function init() {
         // Loading elements on page animations
          ScrollReveal().reveal('.animated__layer', {interval: 150, easing: 'ease-in-out'});
          ScrollReveal().reveal('.standard__block', { interval: 150, easing: 'ease-in-out', distance: '150px' });
          ScrollReveal().reveal('.af-field', { distance: '10px' });
          ScrollReveal().reveal('.acf-form-submit', { distance: '10px' });
          ScrollReveal().reveal('.standard__layer, .introtext', {delay: 300, viewFactor: 0.1});
          ScrollReveal().reveal('#slider', {origin: 'bottom' });
          ScrollReveal().reveal('.breadcrumb', {  origin: 'bottom' });
        //

        const lightbox = new PhotoSwipeLightbox({
          gallery: '#news__gallery',
          children: 'a',
          pswpModule: () => import('photoswipe')
        });
        lightbox.init();

        const lightbox2 = new PhotoSwipeLightbox({
          gallery: '#detail__gallery',
          children: 'a',
          pswpModule: () => import('photoswipe')
        });
        lightbox2.init();

        $(".angle__down__white").on('click', function(event) {

          if (this.hash !== "") {
            event.preventDefault();

            var hash = this.hash;

            $('html, body').animate({
              scrollTop: $(hash).offset().top - 140
            }, 500, function(){

              window.location.hash = hash;
            });
          } // End if
        });

        const mySwiper = new Swiper ('.swiper', {
            direction: 'horizontal',
            spaceBetween: 50,
            autoHeight: true,
            autoplay: {
              delay: 8000,
              disableOnInteraction: false, 
            },
            speed: 1000,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            on: {
              init: function () {
                  // Start de observer om veranderingen in de Swiper-container te volgen
                  const observer = new IntersectionObserver((entries) => {
                      entries.forEach((entry) => {
                          if (entry.isIntersecting) {
                              swiper.autoplay.start(); // Start autoplay als de Swiper-container zichtbaar is
                          } else {
                              swiper.autoplay.stop(); // Stop autoplay als de Swiper-container niet zichtbaar is
                          }
                      });
                  });

                  // Voeg de Swiper-container toe aan de observer
                  observer.observe(this.el);
              }
          }
        })

        const swiper = new Swiper(".swiper__detail", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 3,
        });

        const swiper2 = new Swiper(".swiper__detail2", {
          spaceBetween: 10,
          loop: true,
          autoplay: {
            delay: 4000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
          thumbs: {
            swiper: swiper,
          },
        });

      if (document.querySelector('.swiper-banner')) {
          const mySwiper = new Swiper('.swiper-banner', {
              direction: 'horizontal',
              loop: false, // Schakel de loop-optie uit
              pagination: {
                  el: '.swiper-pagination',
              },

              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },

              effect: 'fade',
              fadeEffect: {
                  crossFade: false,
              },

              speed: 2000,

              autoplay: {
                  delay: 8000,
              },
          });
      }

      $('.sidebar__anchor').click(function(){
          $(this).addClass('btn--hidden');
      });
      
    // }

    // init();

    // document.addEventListener('swup:contentReplaced', (event) => {
    //     init();
    // });
    

});
